import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus';
import 'element-plus/lib/theme-chalk/index.css';
import locale from 'element-plus/lib/locale/lang/zh-cn';
import { Request } from '@/api/request';
import store from "./store";
import Print from '@/assets/js/print';
// import print from 'vue3-print-nb'

import "@/assets/css/app.scss";
import '@/router/permission';

// // 打印
// import print from 'vue-print-nb';


const app = createApp(App);

app.config.globalProperties.$print = print;
Request.init();

app.directive('print', Print);
app.use(router);
app.use(store);
app.use(ElementPlus,{locale});

app.mount('#app');